export const deployStatus = {
  initiated: 'initiated',
  started: 'started',
  failed: 'failed',
  complete: 'complete',
}
